import { useAppDispatch, useAppSelector } from '~system/store/configure-store';
import { selectConfirmationModal } from '~system/store/modal/modal-selectors';
import {
  openConfirmationModal as openConfirmationModalAction,
  closeConfirmationModal as closeConfirmationModalAction,
  ConfirmationModalType,
} from '~system/store/modal/modal-slice';

export const useConfirmationModal = () => {
  const dispatch = useAppDispatch();
  const activeModal = useAppSelector(selectConfirmationModal);

  const openConfirmationModal = (payload: ConfirmationModalType) => {
    dispatch(
      openConfirmationModalAction({
        title: 'Підтвердження',
        content: 'Ви впевнені що хочете виконанти цю дію?',
        ...payload,
      })
    );
  };

  const closeConfirmationModal = () => {
    dispatch(closeConfirmationModalAction());
  };

  return {
    activeModal,
    openConfirmationModal,
    closeConfirmationModal,
  };
};
